import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations.js'
import actions from './action.js'

Vue.use(Vuex)

const state = {
  imageUrl:'http://shared.youdao.com/dict/market/bumblebee/image/logo.png',
  name:'小明',
  base64:''
}
const getters = {
  getBase:state=>{
    return state.base64
  },
  getImageUrl:state=>{
    return state.imageUrl
  },
  getName:state=>{
    return state.name
  }

}
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js